// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer__23byy","logo":"footer__logo__M3Rcr","copyright":"footer__copyright__16vkR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.css
// module id = 804
// module chunks = 0